import { Button, Group, Stack, Text } from '@mantine/core'
import { IconRefreshAlert } from '@tabler/icons-react'
import { memo } from 'react'
import { useCountdown } from '@/shared/lib/time'

export const NotificationTitle = memo(() => {
  return (
    <Group gap="xs">
      <IconRefreshAlert size={24} />
      <Text span>
        New version available
      </Text>
    </Group>
  )
})

interface NotificationContentProps {
  initialCountdown: number
  onReload: () => void
  onCountdownEnd: () => void
}

export const NotificationContent = memo<NotificationContentProps>(({
  initialCountdown,
  onReload,
  onCountdownEnd,
}) => {
  const countdown = useCountdown(initialCountdown, onCountdownEnd)

  return (
    <Stack gap={8}>
      <Text size="sm">
        The app will automatically update in
        {' '}
        {countdown}
        {' '}
        seconds.
      </Text>
      <Group justify="flex-end">
        <Button
          variant="light"
          size="xs"
          mb={1}
          onClick={onReload}
        >
          Update now
        </Button>
      </Group>
    </Stack>
  )
})
